export const SITE = {
  name: "Annette",
  full: "Annette Floral Designer",
  email: "annettefloralweddingdesigner@gmail.com",
  phone: "327 812 5786",
  whatsapp: "393278125786",
  instagram: "https://www.instagram.com/annette_floraldesigner",
  igHandle: "@annette_floraldesigner",
  address: "Via Giuseppe Verdi 7, Casamassima 70010",
  hours: "Lunedì: chiuso\nMartedì: 9/13 – 17/20\nMercoledì: 9/13 – 17/20\nGiovedì: 9/13 · pomeriggio chiuso\nVenerdì: 9/13 – 17/20\nSabato: 9/13 – 17/20\nDomenica: 9/13",
};

export const waLink = (text = "Ciao Annette, vorrei qualche informazione sui tuoi fiori.") =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(text)}`;

export const WEDDING_STYLES = [
  { key: "Vivaci e solari", img: "/img/hero-bouquet.jpg", note: "Colore pieno, luce del sud" },
  { key: "Romantici", img: "/img/w1.jpg", note: "Cipria, morbidezza, poesia" },
  { key: "Moderni e alternativi", img: "/img/w3.jpg", note: "Linee pulite, gesti audaci" },
  { key: "Boho country", img: "/img/w2.jpg", note: "Campo, erbe, libertà" },
];

export const SHOP_CATEGORIES = ["Bouquet", "Composizioni", "Piante", "Ricorrenze", "Eventi"];

export const NAV = [
  { to: "/", label: "Home", id: "home" },
  { to: "/negozio", label: "Negozio", id: "negozio" },
  { to: "/portfolio", label: "Portfolio Wedding", id: "portfolio" },
  { to: "/chi-sono", label: "Chi sono", id: "chi-sono" },
  { to: "/contatti", label: "Contatti", id: "contatti" },
];

export const slug = (s) => s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-");
